import radio from './icons/radio.svg';

const radioStyles = ({ oaoButtons: buttons, palette, spacing }) => ({
  '&::after': {
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    content: '""',
    display: 'block',
    height: 24,
    position: 'absolute',
    width: 24,
  },
  '&::before': {
    background: buttons.primary.color,
    border: `1px solid ${palette.grey.light}`,
    borderRadius: spacing.unit * 3,
    content: '""',
    display: 'block',
    height: 24,
    position: 'relative',
    width: 24,
  },
  '&:checked::after': {
    backgroundImage: `url(${radio})`,
    top: 0,
  },
  '&:checked::before': {
    background: buttons.primary.background,
    border: 'none',
  },
  appearance: 'none',
  position: 'relative',
});

export default radioStyles;
